export type RegularDayKey =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export interface RegularTimeSlot {
  start: string;
  end: string;
}

export interface RegularDaySchedule {
  day: RegularDayKey;
  checked: boolean;
  slots: RegularTimeSlot[];
}

export const REGULAR_DAY_KEYS: RegularDayKey[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];

export function createInitialRegularDays(): RegularDaySchedule[] {
  return REGULAR_DAY_KEYS.map((day) => ({
    day,
    checked: true,
    slots: [{ start: "08:00", end: "09:00" }]
  }));
}

export interface SpecialDateSchedule {
  date: string; // ISO format "YYYY-MM-DD"
  slots: RegularTimeSlot[];
}
